<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>

    <tp-table
      :tableData="list"
      :columns="columns"
      :isPage="0"
    />
  </div>
</template>

<script>
import { getkfUserListAPI, editKfOrderStatusAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";

const columns = [
  {
    label: "ID",
    prop: "id",
    minWidth: "80",
    customRender(h, row) {
      return <p>{row["id"]}</p>;
    },
  },
  {
    label: "姓名",
    prop: "userName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["userName"]}</p>;
    },
  },
  {
    label: "手机号",
    prop: "mobile",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["mobile"]}</p>;
    },
  },
  {
    label: "企微uid",
    prop: "wxcpId",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["wxcpId"]}</p>;
    },
  },
  {
    label: "获客链接",
    prop: "wxcpCustomerAcquisitionLink",
    minWidth: "240",
    customRender(h, row) {
      return <p>{row["wxcpCustomerAcquisitionLink"]}</p>;
    },
  },
  {
    label: '接单状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            class="switch"
            onChange={() => this.changeKfOrderStatus(row)}
            disabled={!this.isShowBtn(this.AUTH_BTN.kf_user_list_take_order_status)}
            v-model={row['kfOrderStatus']}
            active-value={true}
            inactive-value={false}
            active-text="开启"
            inactive-text="关闭"
          ></el-switch>
        </div>
      )
    }
  },
];

export default {
  name: "KfUserList",
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      list: [],
      searchData: {},
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  activated() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      this.list = await getkfUserListAPI() || [];
    },

    // 编辑接单状态
    changeKfOrderStatus(row) {
      let { id, kfOrderStatus } = row;
      let data = { id, kfOrderStatus };
      let statusDesc = kfOrderStatus ? '开启' : '关闭';

      this.$confirm(`此操作将${statusDesc}接单状态, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.kfOrderStatus = kfOrderStatus;
          editKfOrderStatusAPI(data)
            .then(() => {
              this.getList();
              this.$message.success('操作成功');
            })
            .catch(() => {
              row.kfOrderStatus = !kfOrderStatus;
            });
        })
        .catch(() => {
          row.kfOrderStatus = !kfOrderStatus;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }

  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
